/* Shree Book Centre — Series page
 * Selection, live totals, and bulk add-to-cart. All cart operations (resilient
 * add, flying-books, cart drawer, cart:update) run through the shared SBCBulkAdd
 * engine (sbc-bulk-add.js). Every title stays an individual line item.
 */
(function () {
  'use strict';

  var root = document.querySelector('.sbc-series');
  if (!root) return;

  var grid = root.querySelector('[data-series-grid]');
  var sticky = root.querySelector('[data-series-sticky]');
  var mbar = root.querySelector('[data-series-mbar]');
  var toastEl = root.querySelector('[data-series-toast]');
  var toastMsg = root.querySelector('[data-series-toast-msg]');
  var busy = false; // one bulk action at a time

  function inr(cents) { return '₹' + Math.round((cents || 0) / 100).toLocaleString('en-IN'); }
  function cardImgs(cards) { return Array.prototype.map.call(cards, function (c) { return c.querySelector('.sbc-scard__img'); }); }

  /* Series page has its own styled toast element; fall back to the shared one. */
  var toastTimer;
  function toast(msg, warn) {
    if (!toastEl) { if (window.SBCBulkAdd) SBCBulkAdd.toast(msg, warn); return; }
    toastMsg.textContent = msg;
    toastEl.classList.toggle('is-warn', !!warn);
    toastEl.classList.add('is-visible');
    clearTimeout(toastTimer);
    toastTimer = setTimeout(function () { toastEl.classList.remove('is-visible'); }, 3200);
  }

  /* ── selection + live totals ─────────────────────────── */
  function selectedCards() { return grid ? grid.querySelectorAll('.sbc-scard.is-selected') : []; }
  function setText(sel, val) { root.querySelectorAll(sel).forEach(function (el) { el.textContent = val; }); }

  function recompute() {
    var sel = selectedCards();
    var count = sel.length, cents = 0;
    Array.prototype.forEach.call(sel, function (c) { cents += parseInt(c.dataset.price, 10) || 0; });

    setText('[data-series-sel-count]', count);
    setText('[data-series-sel-count-m]', count);
    setText('[data-series-sel-noun]', count === 1 ? 'book' : 'books');
    setText('[data-series-sel-total]', inr(cents));
    setText('[data-series-sel-total-m]', inr(cents));

    if (sticky) sticky.classList.toggle('is-visible', count > 0);
    if (mbar) mbar.classList.toggle('is-visible', count > 0);
  }

  /* Keep the hero counts, panel wording, and available total in sync with the
     live DOM — accurate on load and after any title flips out of stock. */
  function refreshCounts() {
    if (!grid) return;
    var availCards = grid.querySelectorAll('.sbc-scard[data-available="1"]');
    var avail = availCards.length, cents = 0;
    Array.prototype.forEach.call(availCards, function (c) { cents += parseInt(c.dataset.price, 10) || 0; });

    var totalEl = root.querySelector('[data-series-total-num]');
    var total = totalEl ? (parseInt(totalEl.textContent, 10) || grid.querySelectorAll('.sbc-scard').length)
                        : grid.querySelectorAll('.sbc-scard').length;

    setText('[data-series-avail-num]', avail);
    setText('[data-series-avail-count]', '· ' + avail + ' ' + (avail === 1 ? 'book' : 'books'));

    var t = root.querySelector('[data-series-avail-total]');
    if (t) { t.dataset.cents = cents; t.textContent = inr(cents); }

    var sub = root.querySelector('[data-series-panel-sub]');
    if (sub) {
      if (avail === 0) sub.textContent = 'No titles in stock right now';
      else if (avail >= total) sub.innerHTML = '<b>All ' + total + ' titles</b> currently in stock';
      else sub.innerHTML = '<b>' + avail + ' of ' + total + ' titles</b> currently in stock';
    }

    var addAll = root.querySelector('[data-series-add-all]');
    if (addAll && !addAll.classList.contains('is-busy')) addAll.disabled = (avail === 0);
  }

  function toggleCard(card, force) {
    if (!card || card.classList.contains('is-oos')) return;
    var on = force === undefined ? !card.classList.contains('is-selected') : force;
    card.classList.toggle('is-selected', on);
    var chk = card.querySelector('[data-series-check]');
    if (chk) chk.setAttribute('aria-pressed', on ? 'true' : 'false');
  }

  function clearSelection() {
    Array.prototype.forEach.call(grid.querySelectorAll('.sbc-scard.is-selected'), function (c) { toggleCard(c, false); });
    recompute();
  }

  /* ── mark a title unavailable (inventory changed mid-flight) ── */
  function markOOS(card) {
    if (!card) return;
    card.classList.add('is-oos');
    card.classList.remove('is-selected');
    card.dataset.available = '0';
    var wrap = card.querySelector('.sbc-scard__img-wrap');
    var chk = card.querySelector('[data-series-check]');
    if (chk) chk.remove();
    if (wrap && !wrap.querySelector('.sbc-scard__oosband')) {
      var band = document.createElement('span');
      band.className = 'sbc-scard__oosband';
      band.textContent = 'Currently Unavailable';
      wrap.insertBefore(band, wrap.firstChild);
    }
    var add = card.querySelector('[data-series-add]');
    if (add) {
      var note = document.createElement('span');
      note.className = 'sbc-scard__oosnote';
      note.textContent = 'Currently Unavailable';
      add.replaceWith(note);
    }
    refreshCounts();
  }
  function cardByVariant(id) { return grid.querySelector('.sbc-scard[data-variant-id="' + id + '"]'); }

  /* ── button loading state ────────────────────────────── */
  function setLoading(btn, on) {
    if (!btn) return;
    if (on) {
      btn.dataset._html = btn.innerHTML;
      btn.disabled = true;
      btn.classList.add('is-busy');
      btn.innerHTML = '<span class="sbc-series__spin" aria-hidden="true"></span> Adding…';
    } else {
      btn.disabled = false;
      btn.classList.remove('is-busy');
      if (btn.dataset._html != null) { btn.innerHTML = btn.dataset._html; delete btn.dataset._html; }
    }
  }

  /* ── individual add (no drawer auto-open, matching the rest of the site) ── */
  function singleAdd(id, btn) {
    if (btn.disabled || !window.SBCBulkAdd) return;
    var card = btn.closest('.sbc-scard');
    if (card) SBCBulkAdd.fly([card.querySelector('.sbc-scard__img')]);
    var original = btn.innerHTML;
    btn.disabled = true;
    btn.classList.add('is-added');
    btn.innerHTML = '<svg width="13" height="13" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><polyline points="20 6 9 17 4 12"/></svg><span>Added</span>';
    var revertTimer = setTimeout(revert, 2000);
    function revert() { btn.innerHTML = original; btn.classList.remove('is-added'); btn.disabled = false; }

    SBCBulkAdd.addItems([id], { openDrawer: false }).then(function (r) {
      if (r.failed && r.failed.length) {
        clearTimeout(revertTimer); revert();
        markOOS(card); recompute();
        toast('That title just became unavailable', true);
      }
    });
  }

  /* ── bulk add via the shared engine ──────────────────── */
  function bulkRun(ids, cards, btn, clearAfter) {
    if (busy || !ids.length || !window.SBCBulkAdd) return;
    busy = true; setLoading(btn, true);
    SBCBulkAdd.fly(cardImgs(cards));
    SBCBulkAdd.addItems(ids, { openDrawer: true }).then(function (r) {
      (r.failed || []).forEach(function (id) { markOOS(cardByVariant(id)); });
      if (clearAfter) clearSelection(); else recompute();
      if (!r.failed.length) toast(r.added + (r.added === 1 ? ' book' : ' books') + ' added to cart');
      else if (r.added > 0) toast(r.added + ' added · ' + r.failed.length + ' just became unavailable', true);
      else toast('These titles just became unavailable', true);
      setLoading(btn, false); busy = false;
    });
  }

  /* ── wire up ─────────────────────────────────────────── */
  if (grid) {
    grid.addEventListener('click', function (e) {
      var add = e.target.closest('[data-series-add]');
      if (add) { e.preventDefault(); singleAdd(add.getAttribute('data-series-add'), add); return; }
      var chk = e.target.closest('[data-series-check]');
      if (chk) { e.preventDefault(); toggleCard(chk.closest('.sbc-scard')); recompute(); }
      /* clicks on the cover/title links fall through and navigate to the product */
    });
  }

  bind('[data-series-select-all]', function () {
    Array.prototype.forEach.call(grid.querySelectorAll('.sbc-scard[data-available="1"]'), function (c) { toggleCard(c, true); });
    recompute();
  });
  bind('[data-series-clear]', clearSelection);

  bind('[data-series-add-all]', function (e) {
    var cards = grid.querySelectorAll('.sbc-scard[data-available="1"]');
    var ids = Array.prototype.map.call(cards, function (c) { return c.dataset.variantId; }).filter(Boolean);
    bulkRun(ids, cards, e.currentTarget, false);
  });
  root.querySelectorAll('[data-series-add-selected], [data-series-add-selected-m]').forEach(function (btn) {
    btn.addEventListener('click', function () {
      var cards = grid.querySelectorAll('.sbc-scard.is-selected');
      var ids = Array.prototype.map.call(cards, function (c) { return c.dataset.variantId; }).filter(Boolean);
      bulkRun(ids, cards, btn, true);
    });
  });

  function bind(sel, fn) { var el = root.querySelector(sel); if (el) el.addEventListener('click', fn); }

  /* ── init: ₹-group server-rendered prices, then sync counts/selection ── */
  (function initPrices() {
    if (!grid) return;
    grid.querySelectorAll('.sbc-scard').forEach(function (card) {
      var priceEl = card.querySelector('[data-series-price]');
      if (priceEl && card.dataset.price != null) priceEl.textContent = inr(parseInt(card.dataset.price, 10));
      var wasEl = card.querySelector('.sbc-scard__was');
      if (wasEl) {
        var d = (wasEl.textContent.match(/\d+/g) || []).join('');
        if (d) wasEl.textContent = '₹' + parseInt(d, 10).toLocaleString('en-IN');
      }
    });
  })();
  refreshCounts();
  recompute();
})();
